<template>
    <div class="pa-4">
        <div class="content-wrapper">
            <p class="text-xs-left api mb-3 pl-3">Applications</p>
            <div class="box-wrapper" ref="bw">
                <div class="api-box" v-for="api in appList" v-bind:key="api.id">
                    <v-card hover style="height: 100%" @click="showApplicationDetails(api)">
                        <v-layout row justify-start>
                            <v-flex class="pa-3" style="flex-grow: 0"><img :src="api.icon" alt="icon"/></v-flex>
                            <v-flex class="py-3">
                                <v-layout row justify-end class="pr-3">
                                        <span style="opacity: 0; pointer-events: none;">
                                            <v-switch
                                                v-if="token"
                                                v-model="api.enable"
                                                color="success"
                                                class="pa-0 ma-0"
                                            ></v-switch>
                                        </span>
                                </v-layout>
                                <h3 class="api-name">{{ api.name }}</h3>
                            </v-flex>
                        </v-layout>
                        <v-card-text class="text-sm-left text-ellipsis" color="#707070">
                            {{getDescription(api)}}
                        </v-card-text>
                    </v-card>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
    name: 'ApplicationList',
    data () {
        return {
            appList: [
                {
                    name: 'Chat Bot',
                    icon: '/static/img/Chatbot.jpg',
                    path: '/application/chatbot',
                    enable: true,
                    description: 'Build your AI-powered conversation',
                    description_vi: 'Nền tảng tạo lập chatbot ứng dụng trí tuệ nhân tạo'
                },
                {
                    name: 'Reader',
                    icon: 'https://cdn-static-v3.fpt.ai/livesupport-upload-file/44b361485b4b87efb3c0c8b8a9840f05/fe01cbce98f8ac42332befcf79e791ff.png',
                    enable: true,
                    path: '/application/reader',
                    description: 'Build your own AI-Powered reader application',
                    description_vi: 'Xây dựng ứng dụng Nhận dạng & Trích xuất nội dung từ ảnh chụp văn bản'
                },
                {
                    name: 'Voice Maker',
                    icon: 'https://cdn-static-v3.fpt.ai/livesupport-upload-file/e52a8754781959aa4168c2cf8db00c54/e0172e39307b53c02f661bb9b174c043.png',
                    enable: true,
                    path: '/application/voicemaker',
                    description: 'Convert text to speech easily with user-friendly interface',
                    description_vi: 'Ứng dụng chuyển đổi văn bản thành giọng nói với giao diện thân thiện'
                }
            ]
        }
    },
    computed: {
        ...mapState({
            currentProjectId: state => state.user.currentProjectId,
            token: state => state.user.token
        })
    },
    methods: {
        showApplicationDetails (item) {
            this.$router.push(item.path)
        },
        getDescription (item) {
            let locale = this.$i18n.locale
            if (locale === 'en') {
                return item.description
            } else {
                if (item['description_' + locale]) {
                    return item['description_' + locale]
                }
                return item.description
            }
        }
    }
}
</script>

<style scoped>
    .text-ellipsis {
        text-overflow: ellipsis;
        overflow: hidden;
        display: inline-block;
    }

    .api {
        font-size: 29px;
        font-weight: 500;
        color: #707070;
    }

    .api-name {
        font-size: 22px;
        font-weight: 500;
        color: #707070;
    }

    .api-box {
        width: 100%;
        max-width: 300px;
        height: 230px;
        margin: 15px;
    }

    /*.api-box:last-child {*/
    /*    margin: 0;*/
    /*}*/

    /deep/ .v-input--selection-controls__input {
        margin: 0;
    }

    .box-wrapper {
        display: flex;
        flex-wrap: wrap;
    }
</style>
